import * as React from 'react';
import {StatelessComponent  } from 'react';
import {Select, ISelectOption} from '../../select/select';
import {VideoSettingsLabel as Label} from '../label/label';
import {IDevice} from '../../../redux/modules/video-settings';
import {EMPTY} from './constants';

import './styles.sass';

interface IVideoSettingsMediaInputProps {
  deviceId: string;
  devices: Array<IDevice>;
  label: string;
  error: string;
  type: string;
  onChange: (params: ISelectOption) => void;
}

export const VideoSettingsMediaInput: StatelessComponent<IVideoSettingsMediaInputProps> = ({
  deviceId,
  devices,
  label,
  error,
  type,
  onChange,
}) => (
  <div className={'video-settings-media-input'}>
    <Label>{label}</Label>

    {devices.length > 0 ? (
      <Select
        disabled={!devices.length}
        options={devices}
        value={deviceId}
        error={error}
        onChange={onChange}
      />
    ) : (
      <div className={'video-settings-media-input__message'}>
        {EMPTY[type]}
      </div>
    )}
  </div>
);
